(() => {
  const init=()=>{
    const label=document.querySelector('script[data-olouioo-direct-booking]')?.dataset.bookingLabel;
    const decorate=()=>{
      for(const link of document.querySelectorAll('header a')) {
        if(new URL(link.href,location.href).pathname!=='/pages/plan-your-event' || link.textContent.trim().toLowerCase()!=='build your experience')continue;
        if(label)link.textContent=label;
        link.dataset.olouiooBookTrigger='';
        link.setAttribute('aria-haspopup','dialog');
        link.setAttribute('aria-controls','mobile-menu');
      }
    };
    document.addEventListener('click',event=>{
      const link=event.target.closest('a[data-olouioo-book-trigger]');
      if(!link || event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
      const menu=document.getElementById('mobile-menu');
      if(typeof menu?.openDialog!=='function')return;
      event.preventDefault();menu.openDialog(event);
    },true);
    let queued=false;
    new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;decorate();});}}).observe(document.body,{childList:true,subtree:true});
    decorate();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
